import React from "react";
import DashboardMain from "../components/dashboard/DashboardMain";

const DashboardPage: React.FC = () => {
  return (
    // <DashboardMain />
    <React.Fragment>
      <DashboardMain />
    </React.Fragment>
  );
};

export default DashboardPage;
